import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toast } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomFee from 'src/components/shared/CustomFee';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { useStore } from 'src/stores';
const BillingSettingsCustomFee = observer(props => {
  const accountSetupFee = props.accountSetupFee,
    accountSetupFeePrice = props.accountSetupFeePrice,
    customAdminFee = props.customAdminFee,
    customLateFee = props.customLateFee,
    customFee = props.customFee,
    _props$customLateFeeS = props.customLateFeeSign,
    customLateFeeSign = _props$customLateFeeS === void 0 ? undefined : _props$customLateFeeS,
    feeDescription = props.feeDescription,
    handleChange = props.handleChange,
    handleSave = props.handleSave,
    handleCustomLateFeeSignChange = props.handleCustomLateFeeSignChange,
    lateFee = props.lateFee,
    padding = props.padding,
    setFetchFee = props.setFetchFee,
    _props$propertyAccoun = props.propertyAccountSetupFee,
    propertyAccountSetupFee = _props$propertyAccoun === void 0 ? null : _props$propertyAccoun,
    _props$propertyAdminF = props.propertyAdminFee,
    propertyAdminFee = _props$propertyAdminF === void 0 ? undefined : _props$propertyAdminF,
    _props$propertyLateFe = props.propertyLateFee,
    propertyLateFee = _props$propertyLateFe === void 0 ? undefined : _props$propertyLateFe,
    residencyId = props.residencyId,
    setIsLoading = props.setIsLoading;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const propertyFee = accountSetupFee ? Math.min(propertyAccountSetupFee !== null && propertyAccountSetupFee !== void 0 ? propertyAccountSetupFee : accountSetupFeePrice, accountSetupFeePrice).toFixed(2) : lateFee ? propertyLateFee : propertyAdminFee;
  const _useState = useState(feeDescription || ''),
    _useState2 = _slicedToArray(_useState, 2),
    description = _useState2[0],
    setDescription = _useState2[1];
  const _useState3 = useState(customFee),
    _useState4 = _slicedToArray(_useState3, 2),
    feeValue = _useState4[0],
    setFeeValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpened = _useState6[0],
    setIsOpened = _useState6[1];
  useEffect(() => {
    setFeeValue(customFee);
  }, [customFee]);
  const getSign = v => lateFee && customLateFeeSign === FEE_UNIT_TYPES.percentage ? v + '%' : '$' + v;
  const feeText = () => {
    if (feeValue === null) {
      if (propertyFee === null) return 'Not set';else if (propertyFee >= 0) return getSign(propertyFee);
    } else if (feeValue >= 0) {
      return getSign(feeValue.toFixed(2));
    }
    return 'Not set';
  };
  const handleDiscardClick = () => {
    setFeeValue(customFee);
    setIsOpened(false);
  };
  const handleEditClick = () => setIsOpened(!isOpened);

  // The residency-fee POST deletes an admin/late fee that is absent, so every save resends both.
  const getCurrentFees = () => ({
    residencyId,
    adminFee: customAdminFee === null ? null : {
      feeUnitType: FEE_UNIT_TYPES.fixedAmount,
      value: customAdminFee
    },
    lateFee: customLateFee === null ? null : {
      feeUnitType: customLateFeeSign,
      value: customLateFee
    }
  });
  const saveAccountSetupFee = async (value, successMessage) => {
    setIsLoading(true);
    const resp = await store.payment.updateResidencyFeeAsync.run(_objectSpread(_objectSpread({}, getCurrentFees()), {}, {
      accountSetupFee: {
        value
      }
    }));
    setIsLoading(false);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      handleChange(value);
      setDescription(value === null ? feeDescription : t('unit_modal.custom_fee'));
      setIsOpened(false);
      toast('success', {
        body: [successMessage]
      });
    }
  };
  const handleRelink = async () => {
    if (accountSetupFee) return saveAccountSetupFee(null, 'Custom account setup fee successfully set to default');
    setIsLoading(true);
    const data = _objectSpread(_objectSpread({}, getCurrentFees()), {}, {
      [lateFee ? 'lateFee' : 'adminFee']: null
    });
    const updateResidencyFeeResp = await store.payment.updateResidencyFeeAsync.run(data);
    if (updateResidencyFeeResp.isSuccessful) {
      handleChange(null);
      if (lateFee) handleCustomLateFeeSignChange(FEE_UNIT_TYPES.fixedAmount);
      setIsOpened(false);
      setDescription(feeDescription);
      setFetchFee(true);
      toast('success', {
        body: [t('unit_modal.successfull_relink')]
      });
    } else if (setIsLoading) setIsLoading(false);
  };
  const handleSaveClick = () => {
    if (accountSetupFee) {
      if (feeValue > accountSetupFeePrice) {
        toast('error', {
          body: ["Account setup fee must be between $0 and $".concat(accountSetupFeePrice.toFixed(2), ".")]
        });
        return;
      }
      return saveAccountSetupFee(feeValue !== null && feeValue !== void 0 ? feeValue : null, 'Custom account setup fee successfully saved!');
    }
    handleSave(lateFee, feeValue);
    setDescription(t('unit_modal.custom_fee'));
    setIsOpened(false);
  };
  const handleSignChange = (e, value) => handleCustomLateFeeSignChange(value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomFee, {
    customFee: customFee,
    description: description,
    feeText: feeText(),
    feeValue: feeValue,
    handleDiscardClick: handleDiscardClick,
    handleEditClick: handleEditClick,
    handleRelink: handleRelink,
    handleSaveClick: handleSaveClick,
    handleSignChange: handleSignChange,
    lateFee: lateFee,
    isOpened: isOpened,
    padding: padding,
    placeholder: accountSetupFee ? propertyFee : undefined,
    handleInputChange: v => setFeeValue(v),
    sign: customLateFeeSign,
    title: accountSetupFee ? 'Account setup fee' : undefined
  }), accountSetupFee && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    padding: padding
  }, t('add_new_property_flow.asf_caption')));
});
export default BillingSettingsCustomFee;